const styles = {
  chip: (clickable: boolean) => ({
    cursor: clickable ? 'pointer' : 'auto',
  }),
  tooltip: { maxWidth: '42.5rem' },
};

export default styles;
